import axios from 'axios'
import { API_URL } from '@/const'
import { store } from '@/store'

export const getAxiosMsg = async (id) => {
  try {
    const { accessToken } = store.state.app.user
    const headers = {
      Authorization: `Bearer ${accessToken}`
    }
    const { data } = await axios.get(`${API_URL.MESSAGES}/${id}`, { headers })
    return data
  } catch (e) {
    console.log(e.response.data)
  }
  return []
}
